import React, { Component } from 'react';

class FooterRegistration extends Component {
  render() {
    return (
      <div className="footer register">
        <div className="wrapper">
          <div className="copyright">
            © Copyright {new Date().getFullYear()} InstaLinks. All rights reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default FooterRegistration;



// WEBPACK FOOTER //
// ./src/components/FooterRegistration/FooterRegistration.js